<template>
    <b-modal id="bv-modal-add-reason" size="lg" title="Adicionar uma nova prioridade" scrollable centered no-stackin>
        <b-container fluid>
            <form id="priority-form">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="reason-name">Motivo</label>
                            <input type="text" class="form-control" id="reason-name" v-model="form.name" placeholder="nome da prioridade">
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label for="reason-sla">Tempo SLA (H:m)</label>
                            <input 
                                type="text" 
                                class="form-control" 
                                id="reason-sla" 
                                v-model="form.sla"
                                placeholder="Ex: 2530 → 25:30"
                                maxlength="5"
                                @input="formatTimeInput"
                                @blur="validateTimeInput"
                            >
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label for="reason-sla-att">Tempo Primeiro Atendimento(H:m)</label>
                            <input 
                                type="text" 
                                class="form-control" 
                                id="reason-sla-att" 
                                v-model="form.sla_att"
                                placeholder="Ex: 2530 → 25:30"
                                maxlength="5"
                                @input="formatTimeInput"
                                @blur="validateTimeInput"
                            >
                        </div>
                    </div>
                    
                </div>
            </form>
        </b-container>

        <template #modal-footer>
            <div class="d-flex flex-row-reverse justify-content-between" style="width: 100%;">
                <button type="submit" @click.prevent="submitForm" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { convertSecondsToTime } from '../../../helpers/utils';

export default {
    name: "PriorityTicketModal",
    data() {
        return {
            loading: false,
            dataEdit: {},
            form: {
                name: '',
                sla: "00:00",
                sla_att: "00:00",
            }
        }
    },
    computed: {
        isEditing() {
            return this.dataEdit && this.dataEdit.id
        },
    },
    watch: {
        dataEdit: {
            handler(newData) {
                if (newData && Object.keys(newData).length > 0) {
                    this.loadFormData(newData)
                }
            },
            immediate: true
        }
    },
    methods: {
        convertSecondsToTime,
        formatTimeInput(event) {
            const target = event.target.id;
            const text = event.target.value;
            if (text.length > 5) return;
            let value = text.replace(/\D/g, '');
            if (text.includes(":")) {
                if (target == "reason-sla-att") {
                    return this.form.sla_att = text
                }
                return this.form.sla = text
            };
            if (value.length >= 4) {
                let hours = value.slice(0, -2);
                let minutes = value.slice(-2);
                
                if (parseInt(hours) > 99) hours = '99';
                if (parseInt(minutes) > 59) minutes = '59';
                
                if (target == "reason-sla-att") {
                    this.form.sla_att = `${hours}:${minutes}`;
                } else {
                    this.form.sla = `${hours}:${minutes}`;
                }
            } else {
                if (target == "reason-sla-att") {
                    this.form.sla_att = value;
                } else {
                    this.form.sla = value;
                }
            }
        },
        openModal(data) {
            this.resetForm();
            if (data) {
                this.dataEdit = data;
                this.loadFormData(data);
            }
            this.$bvModal.show('bv-modal-add-reason');
        },
        closeModal(data = null) {
            this.loading = false;
            this.resetForm();
            if (data) this.$emit("updateReasonTable", data);
            this.$bvModal.hide('bv-modal-add-reason');
        },
        loadFormData(data) {
            this.form.id = data.id;
            this.form.name = data.name;
            this.form.sla = this.convertSecondsToTime(data.sla, false);
            this.form.sla_att = this.convertSecondsToTime(data.sla_att, false);
        },
        resetForm() {
            this.form = {
                name: '',
                sla: 0,
                sla_att: 0,
            }
            this.dataEdit = {};
        },
        validateTimeInput() {
            const timePattern = /^\d{1,2}:\d{2}$/;
            if (this.form.sla && !timePattern.test(this.form.sla)) {
                Swal.fire({
                    type: "error",
                    text: "Formato de tempo inválido! Use o formato HH:MM (ex: 25:30)"
                });
            } else if (this.form.sla) {
                const [hours, minutes] = this.form.sla.split(':').map(Number);
                if (hours > 99) {
                    Swal.fire({
                        type: "error",
                        text: "Horas não podem ser maiores que 99!"
                    });
                } else if (minutes > 59) {
                    Swal.fire({
                        type: "error",
                        text: "Minutos não podem ser maiores que 59!"
                    });
                }
            }
        },
        validateForm() {
            if (!this.form.name) {
                Swal.fire({
                    type: "error",
                    text: "Campo 'Nome' é obrigatório!"
                });
                return false;
            }

            if (!this.form.sla) {
                Swal.fire({
                    type: "error",
                    text: "Campo 'Tempo' é obrigatório!"
                });
                return false;
            }

            const timePattern = /^\d{1,2}:\d{2}$/;
            if (!timePattern.test(this.form.sla)) {
                Swal.fire({
                    type: "error",
                    text: "Formato de tempo inválido! Use o formato HH:MM (ex: 25:30)"
                });
                return false;
            }

            const [hours, minutes] = this.form.sla.split(':').map(Number);
            if (hours > 99) {
                Swal.fire({
                    type: "error",
                    text: "Horas não podem ser maiores que 99!"
                });
                return false;
            }
            if (minutes > 59) {
                Swal.fire({
                    type: "error",
                    text: "Minutos não podem ser maiores que 59!"
                });
                return false;
            }

            return true;
        },
        async submitForm() {
            if (!this.validateForm()) return;
            this.loading = true;
            const formData = { ...this.form };
            formData.sla = `${formData.sla}:00`;
            formData.sla_att = `${formData.sla_att}:00`;
            try {
                if (this.form.id) {
                    Swal.fire({
                        title: 'Deseja alterar esse motivo?',
                        text: `As alterações realizadas nesse motivo serão aplicadas apenas para as próximas solicitações.`,
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não',
                        type: "question",
                        showCloseButton: true,
                        reverseButtons: true
                    }).then(async ({value}) => {
                        if (!value) return this.loading = false;
                        const { data } = await axios.put("/reason", formData)
                        Swal.fire({
                            type: "success",
                            text: "Motivo atualizado com sucesso."
                        });
                        this.closeModal(data);
                    });
                } else {
                    const { data } = await axios.post("/reason", formData)
                    Swal.fire({
                        type: "success",
                        text: "Motivo salvo com sucesso."
                    });
                    
                    this.closeModal(data);
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    type: "error",
                    text: "Falha ao salvar motivo! Valide todos os campos e tente novamente."
                });
                this.loading = false;
            }
        },
    },
}
</script>

<style scoped>
.range-container {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: sans-serif;
}

input[type="range"] {
    width: 200px;
}
</style>